import { useState } from "react";

const BRANDS = {
  amazon: { name: "Amazon", src: "https://cdn.worldvectorlogo.com/logos/amazon-1.svg" },
  apple: { name: "Apple", src: "https://cdn.simpleicons.org/apple" },
  spotify: { name: "Spotify", src: "https://cdn.simpleicons.org/spotify" },
  netflix: { name: "Netflix", src: "https://cdn.simpleicons.org/netflix" },
  uber: { name: "Uber", src: "https://cdn.simpleicons.org/uber" },
  googleplay: { name: "Google Play", src: "https://cdn.simpleicons.org/googleplay" },
  steam: { name: "Steam", src: "https://cdn.simpleicons.org/steam" },
  xbox: { name: "Xbox", src: "https://cdn.worldvectorlogo.com/logos/xbox-9.svg" },
  playstation: { name: "PlayStation", src: "https://cdn.simpleicons.org/playstation" },
  nintendo: { name: "Nintendo", src: "https://cdn.worldvectorlogo.com/logos/nintendo.svg" },
  minecraft: { name: "Minecraft", src: "https://cdn.worldvectorlogo.com/logos/minecraft-1.svg" },
  careem: { name: "Careem", src: "https://cdn.worldvectorlogo.com/logos/careem.svg" },
  gamestop: { name: "GameStop", src: "https://cdn.worldvectorlogo.com/logos/gamestop.svg" },
  redbull: { name: "Red Bull", src: "https://cdn.simpleicons.org/redbull" },
  ebay: { name: "eBay", src: "https://cdn.simpleicons.org/ebay" },
  roblox: { name: "Roblox", src: "https://cdn.simpleicons.org/roblox" },
  pubg: { name: "PUBG", src: "https://cdn.simpleicons.org/pubg" },
  razer: { name: "Razer", src: "https://cdn.simpleicons.org/razer" },
  discord: { name: "Discord", src: "https://cdn.simpleicons.org/discord" },
  twitch: { name: "Twitch", src: "https://cdn.simpleicons.org/twitch" },
  epicgames: { name: "Epic Games", src: "https://cdn.simpleicons.org/epicgames" },
  ea: { name: "EA", src: "https://cdn.simpleicons.org/ea" },
  riotgames: { name: "Riot Games", src: "https://cdn.simpleicons.org/riotgames" },
  crunchyroll: { name: "Crunchyroll", src: "https://cdn.simpleicons.org/crunchyroll" },
  valorant: { name: "Valorant", src: "https://cdn.simpleicons.org/valorant" },
  leagueoflegends: { name: "League of Legends", src: "https://cdn.simpleicons.org/leagueoflegends" },
  fortnite: { name: "Fortnite", src: "https://cdn.simpleicons.org/fortnite" },
  zomato: { name: "Zomato", src: "https://cdn.simpleicons.org/zomato" },
  swiggy: { name: "Swiggy", src: "https://cdn.simpleicons.org/swiggy" },
  ola: { name: "Ola", src: "https://cdn.worldvectorlogo.com/logos/ola-cabs.svg" },
  tiktok: { name: "TikTok", src: "https://cdn.simpleicons.org/tiktok" },
  tinder: { name: "Tinder", src: "https://cdn.simpleicons.org/tinder" },
  mcafee: { name: "McAfee", src: "https://cdn.simpleicons.org/mcafee" },
  nordvpn: { name: "NordVPN", src: "https://cdn.simpleicons.org/nordvpn" },
  huawei: { name: "Huawei", src: "https://cdn.simpleicons.org/huawei" },
  vodafone: { name: "Vodafone", src: "https://cdn.simpleicons.org/vodafone" },
  orange: { name: "Orange", src: "https://cdn.simpleicons.org/orange" },
  supercell: { name: "Supercell", src: "https://cdn.simpleicons.org/supercell" },
  squareenix: { name: "Square Enix", src: "https://cdn.simpleicons.org/squareenix" },
  activision: { name: "Activision", src: "https://cdn.simpleicons.org/activision" },
  bookmyshow: { name: "BookMyShow", src: "https://cdn.simpleicons.org/bookmyshow" },
  kfc: { name: "KFC", src: "https://cdn.simpleicons.org/kfc" },
  tacobell: { name: "Taco Bell", src: "https://cdn.simpleicons.org/tacobell" },
  starbucks: { name: "Starbucks", src: "https://cdn.simpleicons.org/starbucks" },
  bigbasket: { name: "BigBasket", src: "https://cdn.simpleicons.org/bigbasket" },
  airindia: { name: "Air India", src: "https://cdn.simpleicons.org/airindia" },
  marriott: { name: "Marriott", src: "https://cdn.simpleicons.org/marriott" },
  puma: { name: "Puma", src: "https://cdn.simpleicons.org/puma" },
  ikea: { name: "IKEA", src: "https://cdn.simpleicons.org/ikea" },
  myntra: { name: "Myntra", src: "https://cdn.worldvectorlogo.com/logos/myntra-1.svg" },
  dominos: { name: "Domino's", src: "https://cdn.worldvectorlogo.com/logos/dominos-pizza.svg" },
  pizzahut: { name: "Pizza Hut", src: "https://cdn.worldvectorlogo.com/logos/pizza-hut-2.svg" },
  nykaa: { name: "Nykaa", src: "https://cdn.worldvectorlogo.com/logos/nykaa-1.svg" },
  skechers: { name: "Skechers", src: "https://cdn.worldvectorlogo.com/logos/skechers.svg" },
  decathlon: { name: "Decathlon", src: "https://cdn.worldvectorlogo.com/logos/decathlon-2.svg" },
  flipkart: { name: "Flipkart", src: "https://cdn.worldvectorlogo.com/logos/flipkart.svg" },
  titan: { name: "Titan", src: "https://cdn.worldvectorlogo.com/logos/titan-1.svg" },
  microsoft: { name: "Microsoft", src: "https://cdn.worldvectorlogo.com/logos/microsoft-6.svg" },
  blizzard: { name: "Blizzard", src: "https://cdn.worldvectorlogo.com/logos/blizzard-entertainment.svg" },
  noon: { name: "Noon", src: "https://cdn.worldvectorlogo.com/logos/noon-2.svg" },
  virgin: { name: "Virgin", src: "https://cdn.simpleicons.org/virgin" },
  twok: { name: "2K", src: "https://cdn.simpleicons.org/2k" },
  rockstargames: { name: "Rockstar Games", src: "https://cdn.simpleicons.org/rockstargames" },
  omantel: { name: "Omantel", src: "https://cdn.worldvectorlogo.com/logos/omantel.svg" },
};

const NAME_MATCHERS = [
  [/amazon/i, "amazon"], [/apple/i, "apple"], [/spotify/i, "spotify"], [/netflix/i, "netflix"],
  [/uber/i, "uber"], [/google play/i, "googleplay"], [/steam/i, "steam"], [/xbox/i, "xbox"],
  [/psn|playstation/i, "playstation"], [/nintendo/i, "nintendo"], [/minecraft/i, "minecraft"],
  [/careem/i, "careem"], [/gamestop/i, "gamestop"], [/red bull/i, "redbull"], [/ebay/i, "ebay"],
  [/roblox/i, "roblox"], [/pubg/i, "pubg"], [/razer/i, "razer"], [/discord/i, "discord"],
  [/twitch/i, "twitch"], [/fortnite|epic/i, "fortnite"], [/^ea |^ea$|ea sports|ea fc|ea gift|ea play|ea apex/i, "ea"],
  [/riot|league of legends/i, "riotgames"], [/valorant/i, "valorant"], [/crunchyroll/i, "crunchyroll"],
  [/zomato/i, "zomato"], [/swiggy/i, "swiggy"], [/ola\b/i, "ola"],
  [/tiktok/i, "tiktok"], [/tinder/i, "tinder"], [/mcafee/i, "mcafee"], [/nordvpn/i, "nordvpn"],
  [/huawei/i, "huawei"], [/vodafone/i, "vodafone"], [/orange/i, "orange"],
  [/clash of clans/i, "supercell"], [/final fantasy/i, "squareenix"], [/call of duty/i, "activision"],
  [/blizzard|diablo/i, "blizzard"], [/bookmyshow/i, "bookmyshow"], [/kfc/i, "kfc"],
  [/taco bell/i, "tacobell"], [/starbucks/i, "starbucks"], [/bigbasket/i, "bigbasket"],
  [/air india/i, "airindia"], [/marriott/i, "marriott"], [/puma/i, "puma"], [/ikea/i, "ikea"],
  [/myntra/i, "myntra"], [/domino/i, "dominos"], [/pizza hut/i, "pizzahut"], [/nykaa/i, "nykaa"],
  [/skechers/i, "skechers"], [/decathlon/i, "decathlon"], [/flipkart/i, "flipkart"],
  [/titan/i, "titan"], [/microsoft|windows/i, "microsoft"], [/noon/i, "noon"],
  [/virgin/i, "virgin"], [/nba 2k/i, "twok"], [/gta/i, "rockstargames"], [/omantel/i, "omantel"],
  [/madden|fifa|apex legends/i, "ea"],
];

const DOMAIN_MATCHERS = [
  [/mobily/i, "mobily.com.sa"], [/zain/i, "zain.com"], [/ooredoo/i, "ooredoo.com"],
  [/lebara/i, "lebara.com"], [/lyca/i, "lycamobile.com"], [/walmart/i, "walmart.com"],
  [/paysafecard/i, "paysafecard.com"], [/talabat/i, "talabat.com"], [/airalo/i, "airalo.com"],
  [/starzplay/i, "starzplay.com"], [/bigo/i, "bigolive.tv"], [/imvu/i, "imvu.com"],
  [/sling/i, "sling.com"], [/viu/i, "viu.com"], [/friendi/i, "friendimobile.com"],
  [/salam/i, "salam.sa"], [/syma/i, "symamobile.com"], [/canvaspop/i, "canvaspop.com"],
  [/free ?fire|garena/i, "garena.com"], [/mobile legends/i, "mobilelegends.com"],
  [/guild wars/i, "guildwars2.com"], [/world of (tanks|warships)/i, "wargaming.net"],
  [/runescape/i, "runescape.com"], [/perfect world/i, "perfectworld.com"],
  [/kingsisle/i, "kingsisle.com"], [/likee/i, "likee.com"], [/play dxb/i, "playdxb.com"],
  [/game power 7/i, "gamepower7.com"], [/tq games/i, "tq.com"], [/jumpstart/i, "jumpstart.com"],
  [/yalla ludo/i, "yallaludo.com"],
];

export function matchBrandSlug(name) {
  for (const [re, slug] of NAME_MATCHERS) {
    if (re.test(name)) return slug;
  }
  return null;
}

export function matchBrandSrc(name) {
  const slug = matchBrandSlug(name);
  if (slug && BRANDS[slug]) return BRANDS[slug].src;
  for (const [re, domain] of DOMAIN_MATCHERS) {
    if (re.test(name)) return `https://www.google.com/s2/favicons?domain=${domain}&sz=128`;
  }
  return null;
}

export function brandSrc(slug) {
  return BRANDS[slug] ? BRANDS[slug].src : null;
}

function MarqueeRow({ items, reverse = false }) {
  return (
    <div className="overflow-hidden py-2">
      <div className={`${reverse ? "animate-marquee-reverse" : "animate-marquee"} flex w-max items-center gap-28 pr-28`}>
        {[...items, ...items].map(([slug, b], i) => (
          <img
            key={`${slug}-${i}`}
            src={b.src}
            alt={`${b.name} logo`}
            title={b.name}
            loading="lazy"
            className="h-10 w-auto max-w-[170px] object-contain opacity-70 transition-opacity duration-300 hover:opacity-100"
          />
        ))}
      </div>
    </div>
  );
}

export function BrandMarquee() {
  const entries = Object.entries(BRANDS);
  const third = Math.ceil(entries.length / 3);
  return (
    <div data-testid="brand-marquee" className="space-y-1">
      <MarqueeRow items={entries.slice(0, third)} />
      <MarqueeRow items={entries.slice(third, third * 2)} reverse />
      <MarqueeRow items={entries.slice(third * 2)} />
    </div>
  );
}

export default function BrandLogo({ slug, large = false }) {
  const [failed, setFailed] = useState(false);
  const brand = BRANDS[slug];
  if (!brand) return null;

  return (
    <div
      data-testid={`brand-logo-${slug}`}
      className={`group flex flex-col items-center justify-center gap-2.5 rounded-xl border border-[#e5e9f2] bg-white text-center transition-all duration-300 hover:border-[#f4a900]/60 hover:shadow-[0_10px_24px_-12px_rgba(8,22,168,0.25)] ${
        large ? "px-4 py-5" : "px-3 py-4"
      }`}
      title={brand.name}
    >
      {failed ? (
        <span className="text-xs font-semibold text-[#374151]">{brand.name}</span>
      ) : (
        <img
          src={brand.src}
          alt={`${brand.name} logo`}
          loading="lazy"
          onError={() => setFailed(true)}
          className={`object-contain transition-transform duration-300 group-hover:scale-110 ${
            large ? "h-8 w-8" : "h-6 w-6"
          }`}
        />
      )}
      <span className={`text-[#64748b] transition-colors duration-300 group-hover:text-[#c98a00] ${large ? "text-xs" : "text-[11px]"}`}>
        {brand.name}
      </span>
    </div>
  );
}
